import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormatTime } from '@libs/hooks';
import { useTheme } from 'styled-components';
import { TimerText, TimerContainer, CustomTimerIcon } from './styles';
const Timer = ({ date, className, onTimeOut, formatDaysToString, }) => {
    const { colors } = useTheme();
    const { countDown, formattedString, days } = useFormatTime(formatDaysToString, date, onTimeOut);
    const shouldBeCritical = days
        ? false
        : typeof countDown === 'number' && countDown < 60;
    return (_jsxs(TimerContainer, { className: className, isCritical: shouldBeCritical, children: [_jsx(CustomTimerIcon, { color: colors.text.interactive }), _jsx(TimerText, { color: colors.text.interactive, type: "bodyButton", fontFamily: "primaryMedium", children: formattedString })] }));
};
export default Timer;
//# sourceMappingURL=Timer.js.map